import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "teleport-full-container" }, null, -1)

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useDesignStore, useAppRouter } from '@/store'
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import rootRouter from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

dayjs.locale('zh-cn')

const designStore = useDesignStore()

const appRouter = useAppRouter()

const route = useRoute()

rootRouter.afterEach(() => {
  console.log(' route.fullPath:', route.path)
  let path = ''
  if (route.path.includes('/system')) {
    path = '/system'
  } else if (route.path.includes('/home')) {
    path = '/home'
  } else {
    path = '/health'
  }
  appRouter.router.navbar.selectPath = path
  appRouter.setSiderRoutes()
  // active.value = route.path === '/' ? '/index' : route.path
  // console.log('active:', active.value)
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_config_provider, {
      locale: _unref(zhCN),
      theme: {
        algorithm: _unref(designStore).theme,
      }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale", "theme"]),
    _hoisted_1
  ], 64))
}
}

})